<template lang="pug">
  .height-100
    .modal.is-active(
      key="modal-editar"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      v-if="mostrarConfirmacionEliminar"
      )
      transition(
        name='fade',
        tag="div",
        )
        confirmar-accion-overlay(
          @close="mostrarConfirmacionEliminar = false"
          @do="eliminar()"
        )
          span(slot="title") {{ confirmacionEliminarTitulo }}
          span(slot="information") {{ confirmacionEliminarDescripcion }}
          span(slot="primaryAction")
            template(v-if="isSendingEliminar")
              | Eliminando...
              span.icon.is-small.ml-5
                i.fa.fa-spinner.fa-spin
            template(v-else)
              | Eliminar
    .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
      .title
        span Mis reuniones
      transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
        .filtros-container(key="filtros-container")
          transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
            .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
              h2.text filtros
              .caret
                span.icon
                  i.fa.fa-caret-down(v-if="mostrarFiltros")
                  i.fa.fa-caret-up(v-else)
            .filtros(v-if="mostrarFiltros", key="filtros")
              .columns.is-multiline.display-flex
                .column
                  .filtro
                    .title-singular
                      p Estado
                    .select.display-flex
                      select.flex-1(v-model='filtros.estado' @change="changeFiltro")
                        option(:value="''") Todos
                        option(:value="'1'") Terminado
                        option(:value="'2'") Anulado
                        option(:value="'0'") Pendiente
                .column
                  .filtro.display-flex
                    .title-singular
                      p Creadas por mi
                    .display-flex.mt-5.mb-5
                      input.checkbox.flex-1(v-model='filtros.creadoPorMi' type="checkbox" @change="changeFiltro")
            .boton-container(key="boton-container")
              //- button.button.margin-right-5.is-primary(@click="redirigir(0)")
                span.icon.is-small
                  i.fa.fa-plus
                span Nuevo
              button.button(@click="fetch()")
                span.icon.is-small
                  i.fa.fa-refresh.fa-fw.fa-lg
                span Refrescar
        .body(key="body")
          .information
            transition-group.contenedor-data(
              v-infinite-scroll="fetchByScroll"
              infinite-scroll-disabled="disabledScrollExecute"
              infinite-scroll-distance="2"
              name="fade-smooth-two"
              tag="div"
            )
              .is-desktop(key="is-desktop")
                table.table.is-striped.is-bordered(
                  v-if="lista.length !== 0"
                )
                  thead
                    th Título
                    th Tipo
                    th Asistentes
                    th Fecha
                    th
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="'desktop-table-row-' + index"
                    )
                      td
                        span.hint--top.inline(:aria-label="'ID: ' + o.id") {{ o.titulo }}&nbsp;
                      td
                        span {{ o.tipo === 'capacitacion' ? 'Capacitación' : 'Reunión' }} {{ o.modalidad }}
                      td
                        span {{ o.numeroAsistentes }}
                      td
                        span {{ o.fecha }} {{ o.horaDesde }} - {{ o.horaHasta }}
                      td
                        .contenedor-acciones.display-flex.aic
                          template(v-if="o.codigoCreador === codigo")
                            button.button.is-small.m-2(@click="redirigir(o.id)")
                              span.icon.is-small
                                i.fa.fa-pencil-square-o
                              span Editar
                            button.button.is-small.m-2.is-danger(v-if="o.estado !== 1" @click="confirmarEliminar(o)")
                              span.icon.is-small
                                i.fa.fa-trash
                              span Eliminar
                          button.button.is-small.m-2(@click="verDetalle(o.id)")
                            span.icon.is-small
                              i.fa.fa-pencil-square-o
                            span Ver
              .is-mobile(key="is-mobile")
                .box(
                  v-for="(o, index) in lista"
                  :key="'mobile-table-row-' + index"
                )
                  .status
                    span ASISTENTES: {{ o.numeroAsistentes }}
                  .perfil
                    span.has-text-bold {{ o.tipo === 'capacitacion' ? 'Capacitación' : 'Reunión' }} {{ o.modalidad }}
                  .descripcion-tipo.hint--top(:aria-label="'ID relacionado: ' + o.idRelacionado")
                  .motivo.hint--bottom(:aria-label="'Log: ' + o.id")
                    span.has-text-bold {{ o.titulo }}
                    div.has-text-lef.datos-auditoria
                      //- div
                      //-   span.has-text-bold Accion:&nbsp;
                      //-   span.hint--top.tipo-icon(:aria-label="o.tipo")
                      //-     i(:class="tipoIcon[o.tipo]")
                      //- div(v-for="(value, key) in o.datos")
                      //-   span.has-text-bold {{  key | capitalize }}:&nbsp;
                      //-   span {{  value }}
                    .fecha {{ o.fecha }} {{ o.horaDesde }} {{ o.horaHasta ? `- ${o.horaHasta}` : '' }}
                  .botones
                    template(v-if="o.codigoCreador === codigo")
                      button.button.is-small.m-2(@click="redirigir(o.id)")
                        span.icon.is-small
                          i.fa.fa-pencil-square-o
                        span Editar
                      button.button.is-small.m-2.is-danger(v-if="o.estado !== 1" @click="confirmarEliminar(o)")
                        span.icon.is-small
                          i.fa.fa-trash
                        span Eliminar
                    button.button.is-small.m-2(@click="verDetalle(o.id)")
                      span.icon.is-small
                        i.fa.fa-pencil-square-o
                      span Ver
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .message.is-warning(v-if="lista.length === 0 && !isLoading")
            .message-body
              span.has-text-bold No existe reuniones
</template>

<script>
import ComponentConfirmarAccionOverlay from '../components/Component_Confirmar_Accion_Overlay'
// import moment from 'moment'
import { apiDelete, apiGet, notify } from '../util/general'
export default {
  name: 'gestion-reuniones',
  data () {
    return {
      lista                 : [],
      isLoading             : false,
      isScroll              : false,
      disabledScrollExecute : true,
      skip                  : 0,
      noMore                : false,
      codigo                : +localStorage.getItem('codigo'),
      mostrarConfirmacionEliminar: false,
      confirmacionEliminarTitulo: '',
      confirmacionEliminarDescripcion: '',
      confirmacionEliminarId:'',
      isSendingEliminar: false,
      mostrarFiltros: true,
      filtros : {
        estado: null,
        creadoPorMi: false
      }
    }
  },
  components: {
    'confirmar-accion-overlay': ComponentConfirmarAccionOverlay
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    changeFiltro () {
      this.fetch()
    },
    eliminar () {
      var vm = this
      if (vm.isSendingEliminar) return
      vm.isSendingEliminar = true
      apiDelete(vm, '/reunion/gestion/' + vm.confirmacionEliminarId, {}, function (data) {
        notify(vm, 'success', 'Éxitoso', 'Reunión eliminada.')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSendingEliminar = false
      })
    },
    confirmarEliminar (o) {
      var vm = this

      vm.confirmacionEliminarId = o.id
      vm.confirmacionEliminarTitulo = 'Eliminar reunión'
      vm.confirmacionEliminarDescripcion = '¿Estás seguro de eliminar la reunión ' + o.titulo + '?'

      vm.mostrarConfirmacionEliminar = true
    },
    redirigir (idReunion) {
      var vm = this
      vm.$router.push('/gestion-reuniones/' + idReunion)
    },
    verDetalle (idReunion) {
      var vm = this
      vm.$router.push('/reunion-vista-detallada/' + idReunion)
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      vm.disabledScrollExecute = true
      vm.noMore = false
      var obj = {...vm.filtros}
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, '/reunion/lista', obj, function (data) {
        // poner a las fechas este formato 2018-01-01 00:00:00 con moment
        data.lista.forEach(function (o) {
          // o.fecha = moment(o.fecha).format('DD/MM/YYYY HH:mm:ss')
          vm.lista.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip = +data.numeroRecnum
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px
  .lookup
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde

  .tipo-icon
    i
      font-size 14px
      vertical-align middle

  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: 3px
      right: 7px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
        text-transform: uppercase;
      }
      i
        margin-left: 4px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
    .perfil
      position:absolute;
      top: 3px
      left: 10px
      span {
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
      }
    .descripcion-tipo
      margin-top: 10px;
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
      display flex
      flex-direction column
      align-items center
      position relative
      span
        font-size 18px

      .datos-auditoria
        width: fit-content
        text-align: left
        font-size: 11px
        padding-top 5px
        padding-bottom 10px
        i
          font-size 11px

      .fecha
        position absolute
        bottom 2px
        right 4px
        font-size 11px

  .modal-sidebar-desktop-open
    width: calc(100% - 180px);

  @media (max-width: 1036px)
    .filtros
      flex-direction column
      .filtro
        width 100%
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width 650px)
    .is-mobile
      display block

    .is-desktop
      display none

  @media (max-width 450px)
    .table
      font-size 12px
</style>




// WEBPACK FOOTER //
// View_Reuniones.vue?40dd44a6